import AutoCompleteDropdown from "../../../../../ui library/components/dropdowns/AutoCompleteDropdown";
import HNSColors from "../../../../../ui library/HNSColors";
import { PAYMENTS_MODAL_STYLES } from "../../../../payments/styles/styles";

import AddCustomMedicalItemField from "./AddCustomMedicalItemField";

export default function AddCustomMedicalItemTypeField({
  settlementTypeOptions,
  selectedType,
  onChange,
}) {
  return (
    <div className="flex w-full gap-4">
      <AddCustomMedicalItemField label="Type">
        <AutoCompleteDropdown
          data={settlementTypeOptions}
          initValue={selectedType}
          getOptionLabel={(option) => option?.label || ""}
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          onValueChange={(_, value) => onChange("settlementType", value?.id ?? null)}
          ListboxProps={{
            sx: {
              maxHeight: 200,
              overflow: "auto",
              "&::-webkit-scrollbar": { width: "6px" },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: HNSColors.primary[500],
                borderRadius: "3px",
              },
            },
          }}
          textFieldSx={PAYMENTS_MODAL_STYLES.textField}
          dropdownSx={PAYMENTS_MODAL_STYLES.dropdownPaper}
          disableClearable={true}
        />
      </AddCustomMedicalItemField>
    </div>
  );
}
